export default {
  'SAVE_COMPANY_SKUS' (state, payload) {
    state.items = [...state.items, ...JSON.parse(JSON.stringify(payload))]
  },
  'DESTROY_COMPANY_SKUS' (state) {
    state.items = []
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/company_skus/mutations.js